/**
 * Format timezones data for dropdown display
 * @param {Array} timezones - The timezones array from the API
 * @return {Array} Formatted timezones with unique keys for dropdown
 */
export const formatTimezones = (timezones) => {
  // Handle empty or invalid input
  if (!timezones || !Array.isArray(timezones) || timezones.length === 0) {
    return []
  }

  // Create a map to track used keys and avoid duplicates
  const keyMap = new Map()

  return timezones
    .map((timezone, index) => {
      // Ensure timezone has required fields
      if (!timezone || !timezone.name) {
        console.warn('Invalid timezone object encountered:', timezone)
        return null // Will be filtered out
      }

      // Create a unique value from the timezone id or index if id is missing
      const timezoneValue = timezone.id || `timezone_${index}`

      // Generate a unique key to avoid React warnings
      let key = `tz_${timezoneValue}`
      if (keyMap.has(key)) {
        const count = keyMap.get(key) + 1
        keyMap.set(key, count)
        key = `${key}_${count}`
      } else {
        keyMap.set(key, 1)
      }

      return {
        key, // Unique key for React
        label: timezone.name, // Display name
        value: timezoneValue, // Value for form
      }
    })
    .filter(Boolean) // Remove any null entries
}

export default formatTimezones
